var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"statement-items",attrs:{"headers":_vm.headers,"items":_vm.collapsedItems,"dense":"","hide-default-footer":"","disable-sort":"","mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.price_cents",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.price_cents))+" ")]}},{key:"item.subtotal_cents",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.subtotal_cents))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }